export default String.raw`@media screen and (max-width: 475px){.reminder-container{margin:24px 16px 236px 16px;padding:24px;width:auto}}`